import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import {
  HouseLineIcon,
  LeftDotsPattern,
  ListBulletsIcon,
  MapPinSimpleAreaIcon,
  MapTrifoldIcon,
  MusicNotesIcon,
  NotePencilIcon,
  RightDotsPattern,
  ShareIcon,
} from './JourneyIcons';

export function JourneySection() {
  const { t, i18n } = useTranslation('home');

  const JOURNEY_STEPS = [
    {
      icon: <MapTrifoldIcon />,
      titleKey: 'journey.steps.explore',
    },
    {
      icon: <ListBulletsIcon />,
      titleKey: 'journey.steps.search',
    },
    {
      icon: <NotePencilIcon />,
      titleKey: 'journey.steps.reserve',
    },
    {
      icon: <HouseLineIcon />,
      titleKey: 'journey.steps.moveIn',
    },
    {
      icon: <MapPinSimpleAreaIcon />,
      titleKey: 'journey.steps.settleIn',
    },
    {
      icon: <MusicNotesIcon />,
      titleKey: 'journey.steps.enjoyLife',
    },
    {
      icon: <ShareIcon />,
      titleKey: 'journey.steps.moveOut',
    },
  ];

  return (
    <section className="relative mx-auto my-16 flex w-full max-w-[1100px] flex-col gap-y-8 px-5 md:my-[120px] md:flex-row md:gap-x-[190px] md:gap-y-0 md:px-0">
      <div className="flex flex-col gap-y-4 md:mt-[72px] md:gap-y-[26px]">
        <h2 className="whitespace-pre-line text-2xl font-bold leading-[1.3] tracking-[-0.022em] text-black md:text-[28px]">
          <Trans
            i18nKey="home:journey.title"
            components={{
              br: <br />,
              strong: <strong className="text-primary" />,
            }}
          />
        </h2>
        <p className="whitespace-pre-line text-base font-medium leading-[1.5] tracking-[-0.022em] text-[#717171] md:text-[20px] md:leading-[1.4]">
          <Trans
            i18nKey="home:journey.description"
            components={{
              br: <br />,
              strong: <strong />,
            }}
          />
        </p>
      </div>

      <div className="relative flex flex-col">
        <div className="flex flex-col gap-y-4 rounded-[20px] bg-[#FFF7F7] px-5 py-6 md:gap-y-[24px] md:px-[42px] md:py-[42px]">
          {JOURNEY_STEPS.map((step) => (
            <React.Fragment key={step.titleKey}>
              <div className="flex w-full items-center gap-x-4 md:w-[400px] md:gap-x-[24px]">
                <div className="relative z-10 flex h-[44px] w-[44px] flex-shrink-0 items-center justify-center rounded-full bg-[#FFEBEB] text-[#FF2D2E]">
                  {step.icon}
                </div>
                <h3
                  className={`font-semibold leading-[1.4] tracking-[-0.022em] text-[#222222] md:text-[20px] ${
                    i18n.language === 'vi' ? 'text-sm' : 'text-base'
                  }`}
                >
                  {t(step.titleKey)}
                </h3>
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* Vertical divider line (behind icons) */}
        <div className="pointer-events-none absolute left-[42px] top-6 z-0 h-[calc(100%-48px)] w-[2px] bg-[#FFC5C5] md:left-[62px] md:top-[42px] md:h-[420px]" />

        {/* Left Dots Pattern */}
        <div className="absolute left-[-70px] top-[420px] hidden md:block">
          <LeftDotsPattern />
        </div>

        {/* Right Dots Pattern */}
        <div className="absolute right-[-52px] top-[170px] hidden md:block">
          <RightDotsPattern />
        </div>
      </div>
    </section>
  );
}
